import { data } from 'jquery';
import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import CreateTableComponent from "../../share/CreateTableComponent";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";



export function Report55Component() {


    const currentYearTh = new Date().getFullYear() + 543;
    const [loading, setLoading] = useState(false);
    const [budgetYear, setBudgetYear] = useState(currentYearTh);
    const [reportData, setReportData] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);

    /* ================= EXPORT EXCEL ================= */

    const exportExcel = () => {

        const wb = XLSX.utils.book_new();

        const wsData = [];

        /* ================= HEADER ROW 1 ================= */
        const headerRow1 = [
            "ลำดับ",
            "รายการ",
            ...Array(36).fill("อนุมัติเงินอุดหนุน"),
            "", "", ""
        ];

        /* ================= HEADER ROW 2 ================= */

        const months = [
            `ตุลาคม ${budgetYear - 1}`,
            `พฤศจิกายน ${budgetYear - 1}`,
            `ธันวาคม ${budgetYear - 1}`,
            `มกราคม ${budgetYear}`,
            `กุมภาพันธ์ ${budgetYear}`,
            `มีนาคม ${budgetYear}`,
            `เมษายน ${budgetYear}`,
            `พฤษภาคม ${budgetYear}`,
            `มิถุนายน ${budgetYear}`,
            `กรกฎาคม ${budgetYear}`,
            `สิงหาคม ${budgetYear}`,
            `กันยายน ${budgetYear}`
        ];

        const headerRow2 = ["", ""];

        months.forEach(m => {
            headerRow2.push(m, "", "");
        });

        headerRow2.push("รวม", "", "");

        /* ================= HEADER ROW 3 ================= */

        const headerRow3 = ["", ""];

        for (let i = 0; i < 13; i++) {
            headerRow3.push("(แห่ง)", "คน", "(บาท)");
        }

        wsData.push(headerRow1);
        wsData.push(headerRow2);
        wsData.push(headerRow3);

        /* ================= DATA ================= */

        reportData.forEach((row, index) => {

            let totalSupport = 0;
            let totalPerson = 0;
            let totalAmount = 0;

            const rowData = [index + 1, row.supportTypeName];

            row.detailMonth.forEach(m => {

                rowData.push(m.supportAmount || 0);
                rowData.push(m.personAmount || 0);
                rowData.push(m.amount || 0);

                totalSupport += m.supportAmount || 0;
                totalPerson += m.personAmount || 0;
                totalAmount += m.amount || 0;
            });

            rowData.push(totalSupport);
            rowData.push(totalPerson);
            rowData.push(totalAmount);

            wsData.push(rowData);
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);

        /* ================= MERGE CELLS ================= */

        ws["!merges"] = [

            // ลำดับ + รายการ rowspan 3
            { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } },
            { s: { r: 0, c: 1 }, e: { r: 2, c: 1 } },

            // อนุมัติเงินอุดหนุน colspan 36
            { s: { r: 0, c: 2 }, e: { r: 0, c: 37 } },

            // รวม colspan 3
            { s: { r: 1, c: 38 }, e: { r: 1, c: 40 } },
        ];

        XLSX.utils.book_append_sheet(wb, ws, "Report55");
        XLSX.writeFile(wb, `Report55_${budgetYear}.xlsx`);
    };


    /* ================= EXPORT PDF ================= */

    function base64FromArrayBuffer(buf) {
        const bytes = new Uint8Array(buf);
        const chunkSize = 0x8000;
        let binary = "";
        for (let i = 0; i < bytes.length; i += chunkSize) {
            binary += String.fromCharCode.apply(
                null,
                bytes.subarray(i, i + chunkSize)
            );
        }
        return btoa(binary);
    }

    let thaiFontLoaded = false;

    async function ensureThaiFontLoaded() {
        if (thaiFontLoaded) return;

        const [regRes, boldRes] = await Promise.all([
            fetch("/fonts/Sarabun-Regular.ttf"),
            fetch("/fonts/Sarabun-Bold.ttf")
        ]);

        const [regBuf, boldBuf] = await Promise.all([
            regRes.arrayBuffer(),
            boldRes.arrayBuffer()
        ]);

        const regB64 = base64FromArrayBuffer(regBuf);
        const boldB64 = base64FromArrayBuffer(boldBuf);

        jsPDF.API.events.push([
            "addFonts",
            function () {
                this.addFileToVFS("Sarabun-Regular.ttf", regB64);
                this.addFileToVFS("Sarabun-Bold.ttf", boldB64);
                this.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");
                this.addFont("Sarabun-Bold.ttf", "Sarabun", "bold");
            }
        ]);

        new jsPDF();
        thaiFontLoaded = true;
    }

    async function exportPDF() {
        if (!reportData.length) return;

        await ensureThaiFontLoaded();

        const months = [
            `ตุลาคม ${budgetYear - 1}`,
            `พฤศจิกายน ${budgetYear - 1}`,
            `ธันวาคม ${budgetYear - 1}`,
            `มกราคม ${budgetYear}`,
            `กุมภาพันธ์ ${budgetYear}`,
            `มีนาคม ${budgetYear}`,
            `เมษายน ${budgetYear}`,
            `พฤษภาคม ${budgetYear}`,
            `มิถุนายน ${budgetYear}`,
            `กรกฎาคม ${budgetYear}`,
            `สิงหาคม ${budgetYear}`,
            `กันยายน ${budgetYear}`
        ];

        // ===== คำนวณผลรวม footer ให้เหมือนตารางบนจอ =====
        const monthTotals = Array.from({ length: 12 }, () => ({
            support: 0,
            person: 0,
            amount: 0
        }));

        let grandSupport = 0;
        let grandPerson = 0;
        let grandAmount = 0;

        reportData.forEach(row => {
            row.detailMonth.forEach((m, index) => {
                const support = Number(m.supportAmount || 0);
                const person = Number(m.personAmount || 0);
                const amount = Number(m.amount || 0);

                monthTotals[index].support += support;
                monthTotals[index].person += person;
                monthTotals[index].amount += amount;

                grandSupport += support;
                grandPerson += person;
                grandAmount += amount;
            });
        });

        // ===== body =====
        const body = reportData.map((row, index) => {
            let totalSupport = 0;
            let totalPerson = 0;
            let totalAmount = 0;

            const rowData = [
                index + 1,
                row.supportTypeName
            ];

            row.detailMonth.forEach(m => {
                const support = Number(m.supportAmount || 0);
                const person = Number(m.personAmount || 0);
                const amount = Number(m.amount || 0);

                rowData.push(NumberWithCommmas2(support));
                rowData.push(NumberWithCommmas2(person));
                rowData.push(NumberWithCommmas2(amount));

                totalSupport += support;
                totalPerson += person;
                totalAmount += amount;
            });

            rowData.push(
                NumberWithCommmas2(totalSupport),
                NumberWithCommmas2(totalPerson),
                NumberWithCommmas2(totalAmount)
            );

            return rowData;
        });

        // ===== footer row =====
        const footerRow = [
            { content: "รวมทั้งสิ้น", colSpan: 2, styles: { halign: "center", fontStyle: "bold" } }
        ];

        monthTotals.forEach(m => {
            footerRow.push(NumberWithCommmas2(m.support));
            footerRow.push(NumberWithCommmas2(m.person));
            footerRow.push(NumberWithCommmas2(m.amount));
        });

        footerRow.push(
            NumberWithCommmas2(grandSupport),
            NumberWithCommmas2(grandPerson),
            NumberWithCommmas2(grandAmount)
        );

        // ===== กำหนดขนาดกระดาษแบบ dynamic =====
        // 41 columns = 2 คอลัมน์หลัก + (12 เดือน x 3) + รวม 3
        const totalColumns = 41;

        const noColWidth = 40;          // ลำดับ
        const nameColWidth = 180;       // รายการ
        const valueColWidth = 58;       // ตัวเลขแต่ละช่อง
        const leftRightMargin = 30 * 2;

        const estimatedTableWidth =
            noColWidth +
            nameColWidth +
            (totalColumns - 2) * valueColWidth;

        const pageWidth = Math.max(1190, estimatedTableWidth + leftRightMargin); // อย่างน้อย A3 แนวนอน
        const pageHeight = 842; // ความสูงประมาณ A3 landscape

        const doc = new jsPDF({
            orientation: "landscape",
            unit: "pt",
            format: [pageHeight, pageWidth]
        });

        doc.setFont("Sarabun", "bold");
        doc.setFontSize(14);
        doc.text(`การอนุมัติให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน ปีงบประมาณ ${budgetYear}`, 30, 30);

        // ===== header 3 ชั้น ให้เหมือนตารางบนจอ =====
        const headRow1 = [
            { content: "ลำดับ", rowSpan: 3, styles: { halign: "center", valign: "middle" } },
            { content: "รายการ", rowSpan: 3, styles: { halign: "center", valign: "middle" } },
            { content: "อนุมัติเงินอุดหนุน", colSpan: 36, styles: { halign: "center", valign: "middle" } },
            { content: "", colSpan: 3, styles: { halign: "center", valign: "middle" } }
        ];

        const headRow2 = [];
        months.forEach(m => {
            headRow2.push({
                content: m,
                colSpan: 3,
                styles: { halign: "center", valign: "middle" }
            });
        });
        headRow2.push({
            content: "รวม",
            colSpan: 3,
            styles: { halign: "center", valign: "middle" }
        });

        const headRow3 = [];
        for (let i = 0; i < 13; i++) {
            headRow3.push("(แห่ง)");
            headRow3.push("คน");
            headRow3.push("(บาท)");
        }

        doc.setFont("Sarabun", "normal");

        autoTable(doc, {
            startY: 45,
            head: [headRow1, headRow2, headRow3],
            body,
            foot: [footerRow],
            theme: "grid",
            margin: { top: 45, right: 30, bottom: 20, left: 30 },
            tableWidth: "auto",
            styles: {
                font: "Sarabun",
                fontSize: 6,
                cellPadding: 3,
                lineColor: [120, 120, 120],
                lineWidth: 0.3,
                overflow: "linebreak",
                halign: "right",
                valign: "middle"
            },
            headStyles: {
                font: "Sarabun",
                fontStyle: "bold",
                fontSize: 6,
                fillColor: [240, 240, 240],
                textColor: [0, 0, 0],
                halign: "center",
                valign: "middle"
            },
            footStyles: {
                font: "Sarabun",
                fontStyle: "bold",
                fontSize: 6,
                fillColor: [230, 230, 230],
                textColor: [0, 0, 0],
                halign: "right"
            },
            columnStyles: {
                0: { cellWidth: noColWidth, halign: "center" },
                1: { cellWidth: nameColWidth, halign: "left" },

                2: { cellWidth: valueColWidth },
                3: { cellWidth: valueColWidth },
                4: { cellWidth: valueColWidth },
                5: { cellWidth: valueColWidth },
                6: { cellWidth: valueColWidth },
                7: { cellWidth: valueColWidth },
                8: { cellWidth: valueColWidth },
                9: { cellWidth: valueColWidth },
                10: { cellWidth: valueColWidth },
                11: { cellWidth: valueColWidth },
                12: { cellWidth: valueColWidth },
                13: { cellWidth: valueColWidth },
                14: { cellWidth: valueColWidth },
                15: { cellWidth: valueColWidth },
                16: { cellWidth: valueColWidth },
                17: { cellWidth: valueColWidth },
                18: { cellWidth: valueColWidth },
                19: { cellWidth: valueColWidth },
                20: { cellWidth: valueColWidth },
                21: { cellWidth: valueColWidth },
                22: { cellWidth: valueColWidth },
                23: { cellWidth: valueColWidth },
                24: { cellWidth: valueColWidth },
                25: { cellWidth: valueColWidth },
                26: { cellWidth: valueColWidth },
                27: { cellWidth: valueColWidth },
                28: { cellWidth: valueColWidth },
                29: { cellWidth: valueColWidth },
                30: { cellWidth: valueColWidth },
                31: { cellWidth: valueColWidth },
                32: { cellWidth: valueColWidth },
                33: { cellWidth: valueColWidth },
                34: { cellWidth: valueColWidth },
                35: { cellWidth: valueColWidth },
                36: { cellWidth: valueColWidth },
                37: { cellWidth: valueColWidth },
                38: { cellWidth: valueColWidth },
                39: { cellWidth: valueColWidth },
                40: { cellWidth: valueColWidth }
            },
            didDrawPage: function (data) {
                const pageCount = doc.internal.getNumberOfPages();
                doc.setFont("Sarabun", "normal");
                doc.setFontSize(8);
                doc.text(
                    `หน้า ${doc.internal.getCurrentPageInfo().pageNumber} / ${pageCount}`,
                    data.settings.margin.left,
                    doc.internal.pageSize.height - 8
                );
            }
        });

        doc.save(`การอนุมัติให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน_${budgetYear}.pdf`);
    }




    async function fetchReport655() {
        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("budgetYear", budgetYear);

            const res = await fetch("/api/SupportReports/dataReport55", {
                method: "POST",
                body: formData
            });

            const json = await res.json();
            setReportData(json.dataenum || []);
        }
        finally {
            setLoading(false);
        }
    }

    async function fetchYearOptions() {
        const res = await fetch("/api/Support/getyear57");
        const json = await res.json();
        setYearOptions(json.dataenum || []);
    }


    useEffect(() => {
        fetchReport655();
        fetchYearOptions();
    }, [budgetYear]);





    return (
        <Container>

            <Row className="mb-3 align-items-center">
                <Col md={4} sm={12} className="text-end"><h5>ปีงบประมาณ</h5></Col>

                <Col md={5} sm={12}>
                    <Input
                        type="select"
                        value={budgetYear}
                        disabled={loading}
                        onChange={e => setBudgetYear(e.target.value)}
                    >
                        {yearOptions.map(y => (
                            <option key={y.yearTh} value={y.yearTh}>
                                {y.yearTh}
                            </option>
                        ))}
                    </Input>
                </Col>


                <Col md={3} className="text-end">
                    <Button
                        className="btn-export excel me-2"
                        onClick={exportExcel}
                        disabled={loading || !reportData.length}
                    >
                        Excel
                    </Button>
                    <Button
                        className="btn-export pdf"
                        onClick={exportPDF}
                        disabled={loading || !reportData.length}
                    >
                        PDF
                    </Button>
                </Col>
            </Row>

            {/* ===== TABLE ===== */}
            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" />
                    <div className="mt-2">กำลังโหลดข้อมูล...</div>
                </div>
            ) : (
                <Table
                    bordered
                    hover
                    responsive
                    className="report-table text-center"
                    style={{
                        minWidth: "4000px",
                        // fontSize: "13px"
                    }}
                >
                    <thead>
                        <tr>
                            <th rowSpan="3">
                                ลำดับ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                รายการ
                            </th>
                            <th colSpan="36" className=' text-center'>
                                อนุมัติเงินอุดหนุน
                            </th>
                            <th colSpan="3" className=' text-center'>

                            </th>
                        </tr>
                        <tr>
                            <th colSpan="3" className='text-center'>
                                ตุลาคม {budgetYear - 1}
                            </th>
                            <th colSpan="3" className='text-center'>
                                พฤศจิกายน {budgetYear - 1}
                            </th>
                            <th colSpan="3" className='text-center'>
                                ธันวาคม {budgetYear - 1}
                            </th>
                            <th colSpan="3" className='text-center'>
                                มกราคม {budgetYear}
                            </th>
                            <th colSpan="3" className='text-center'>
                                กุมภาพันธ์ {budgetYear}
                            </th>
                            <th colSpan="3" className='text-center'>
                                มีนาคม {budgetYear}
                            </th>
                            <th colSpan="3" className='text-center'>
                                เมษายน {budgetYear}
                            </th>
                            <th colSpan="3" className='text-center'>
                                พฤษภาคม {budgetYear}
                            </th>
                            <th colSpan="3" className='text-center'>
                                มิถุนายน {budgetYear}
                            </th>
                            <th colSpan="3" className='text-center'>
                                กรกฎาคม {budgetYear}
                            </th>
                            <th colSpan="3" className='text-center'>
                                สิงหาคม {budgetYear}
                            </th>
                            <th colSpan="3" className='text-center'>
                                กันยายน {budgetYear}
                            </th>
                            <th colSpan="3" className='text-center'>
                                รวม
                            </th>
                        </tr>
                        <tr>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                            <th className='text-center'>
                                (แห่ง)
                            </th>
                            <th className='text-center'>
                                คน
                            </th>
                            <th className='text-center'>
                                (บาท)
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {reportData.map((row, i) => {

                            let totalSupport = 0;
                            let totalPerson = 0;
                            let totalAmount = 0;

                            return (
                                <tr key={row.supportTypeId}>
                                    <td>{i + 1}</td>
                                    <td className="text-start">{row.supportTypeName}</td>

                                    {row.detailMonth.map((data, j) => {

                                        totalSupport += data.supportAmount || 0;
                                        totalPerson += data.personAmount || 0;
                                        totalAmount += data.amount || 0;

                                        return (
                                            <React.Fragment key={j}>
                                                <td className='text-end'>{NumberWithCommmas2(data.supportAmount)}</td>
                                                <td className='text-end'>{NumberWithCommmas2(data.personAmount)}</td>
                                                <td className='text-end'>{NumberWithCommmas2(data.amount)}</td>
                                            </React.Fragment>
                                        );
                                    })}

                                    {/* ====== COLUMN รวม ====== */}
                                    <td className="fw-bold text-end">
                                        {NumberWithCommmas2(totalSupport)}
                                    </td>
                                    <td className="fw-bold text-end">
                                        {NumberWithCommmas2(totalPerson)}
                                    </td>
                                    <td className="fw-bold text-end">
                                        {NumberWithCommmas2(totalAmount)}
                                    </td>

                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        {(() => {

                            // เตรียม array สำหรับเก็บผลรวม 12 เดือน
                            const monthTotals = Array.from({ length: 12 }, () => ({
                                support: 0,
                                person: 0,
                                amount: 0
                            }));

                            let grandSupport = 0;
                            let grandPerson = 0;
                            let grandAmount = 0;

                            reportData.forEach(row => {
                                row.detailMonth.forEach((m, index) => {

                                    monthTotals[index].support += m.supportAmount || 0;
                                    monthTotals[index].person += m.personAmount || 0;
                                    monthTotals[index].amount += m.amount || 0;

                                    grandSupport += m.supportAmount || 0;
                                    grandPerson += m.personAmount || 0;
                                    grandAmount += m.amount || 0;
                                });
                            });

                            return (
                                <tr className="table-secondary fw-bold">
                                    <td colSpan={2} className="text-center">
                                        รวมทั้งสิ้น
                                    </td>

                                    {monthTotals.map((m, i) => (
                                        <React.Fragment key={i}>
                                            <td className="text-end">
                                                {NumberWithCommmas2(m.support)}
                                            </td>
                                            <td className="text-end">
                                                {NumberWithCommmas2(m.person)}
                                            </td>
                                            <td className="text-end">
                                                {NumberWithCommmas2(m.amount)}
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    {/* รวมคอลัมน์สุดท้าย */}
                                    <td className="text-end">
                                        {NumberWithCommmas2(grandSupport)}
                                    </td>
                                    <td className="text-end">
                                        {NumberWithCommmas2(grandPerson)}
                                    </td>
                                    <td className="text-end">
                                        {NumberWithCommmas2(grandAmount)}
                                    </td>
                                </tr>
                            );
                        })()}
                    </tfoot>

                </Table>
            )}

        </Container>


    )
}